import React, { useState, memo, useEffect } from "react";
import styled from "styled-components";
import Box from "components/Box";

function Question({
  questionKey: key,
  question,
  progress = {},
  onSubmit,
  questionNumber,
  group
}) {
  let [answer, setAnswer] = useState(null);
  let ref = React.useRef();

  useEffect(() => {
    if (Object.keys(progress).includes(question.questionKey)) {
      setAnswer(progress[question.questionKey]);
    } else {
      setAnswer(null);
    }
  }, [progress, question]);

  // #region questionNumber fix hack
  useEffect(() => {
    if (question.isParagraph) {
      return;
    }
    ref.current.childNodes[0].innerHTML =
      questionNumber + ". " + ref.current.childNodes[0].innerHTML;
  }, [questionNumber]);
  // #endregion

  function onAnswerChange(event) {
    setAnswer(event.target.value);
    onSubmit(key, event.target.value);
  }

  console.log("@@group", group);
  return (
    <Box boxShadow={10} padding={"20px 30px"} style={{ margin: 0 }}>
      {group ? (
        <div>
          <p style={{ color: "black", fontStyle: "italic" }}>
            Study the paragraph and answer the Question
          </p>
          <span
            style={{
              fontSize: "18px",
              lineHeight: "1.2em",
              minHeight: "3.6em",
              margin: "0",
              color: "#44576F"
            }}
            dangerouslySetInnerHTML={{ __html: group.question }}
          ></span>
        </div>
      ) : null}
      <p
        ref={ref}
        dangerouslySetInnerHTML={{ __html: question.question }}
        style={{
          fontWeight: "bold",
          fontSize: "18px",
          lineHeight: "1.2em",
          minHeight: "3.6em",
          margin: "0",
          color: "#44576F"
        }}
      />
      <div onChange={onAnswerChange}>
        {["a", "b", "c", "d"].map(i => (
          <React.Fragment key={i}>
            <Label htmlFor={"option-" + i} key={answer} current={i === answer}>
              <input
                type="radio"
                checked={i === answer}
                name="option"
                value={i}
                id={"option-" + i}
                style={{ display: "none" }}
                onClick={() => {}}
              />
              <span style={{ marginRight: 10 }}>
                {i}
                {")"}
              </span>
              <span dangerouslySetInnerHTML={{ __html: question[i] }} />
            </Label>
            <br />
          </React.Fragment>
        ))}
      </div>
    </Box>
  );
}

export default memo(Question);

const Label = styled.label`
  width: 100%;
  display: inline-block;
  margin-bottom: 15px;
  border: 1px solid #80808052;
  cursor: pointer;
  padding: 10px;
  font-weight: 600;
  background: ${({ current }) => (current ? "#2DBC9C" : "white")};
  color: ${({ current }) => (current ? "white" : "black")};
  border-radius: 4px;
`;

const ParagraphContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;
